
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/franchise/[slug]",
      function () {
        return require("private-next-pages/[locale]/franchise/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/franchise/[slug]"])
      });
    }
  